/** Підпис чипа застосованої умови розширених фільтрів: «Статус дорівнює Чинний», «Назва містить «міст»», «Термін порожнє». */

/** Текстове значення береться в «лапки», вибране зі списку — як є; умова без значення — лише «поле умова». Чиста функція. */
export function conditionLabel(field: string, op: string, value: string | null, quoted: boolean): string {
  if (value === null) return `${field} ${op}`;
  return `${field} ${op} ${quoted ? `«${value}»` : value}`;
}
